export default __webpack_public_path__ + "static/media/vesp.2aab0f1a.png";